import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_5sfnb3y1: FaireBrandEntity = {
  token: "b_5sfnb3y1",
  type: "brand",
  name: "Aspen Lane",
  avatarUrl:
    "https://cdn.faire.com/fastly/e918878b5e2d54549392d3bda42c5f354292e2f2b5f6ccaf73db4a562f035207.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/e067ca60cf192b7f55bb22badd8b2cb215e9febb7beb025cdc20fe62e70104d4.png",
  logoUrl:
    "https://cdn.faire.com/fastly/e918878b5e2d54549392d3bda42c5f354292e2f2b5f6ccaf73db4a562f035207.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e067ca60cf192b7f55bb22badd8b2cb215e9febb7beb025cdc20fe62e70104d4.png",
  location: "Denver, CO, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 152,
  isTopShop: true,
  isInsider: true,
  description:
    "If we haven't met, I'm Mika, founder of Aspen Lane. Since starting in 2014, Aspen Lane is on a mission to create products for all of life's gifting seasons. Our roots go deep and wide-just like the Aspen trees and groves do that our company was named after. Our products fit your modern gift store needs: general gift, baby, and motherhood.\n\nThank you for supporting us through the years, and the best is yet to come. \n\nxoxo,    Mika Shreeve\n              Founder, Aspen Lane\n              Mom to 2 Boys (5 and 2) ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:35.373Z",
    importedBy: "entity-db-cli",
  },
};
